import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'

function LicenseAvailability({ license, isAssigned = false, isGws = false }) {
  if (isGws) {
    return <FormattedMessage id={isAssigned ? 'GENERAL.ASSIGNED' : 'ENGAGE.UNASSIGNED'} />
  }

  if (license.availableLicences > 0) {
    return (
      <FormattedMessage
        id="ENGAGE.LICENSES_AVAILABLE"
        values={{
          available: license.availableLicences,
          total: license.totalLicences,
        }}
      />
    )
  }

  return <FormattedMessage id="ENGAGE.NO_LICENSES_AVAILABLE" />
}

LicenseAvailability.propTypes = {
  license: PropTypes.shape({
    availableLicences: PropTypes.number,
    totalLicences: PropTypes.number,
  }).isRequired,
  isAssigned: PropTypes.bool,
  isGws: PropTypes.bool,
}

export default React.memo(LicenseAvailability)
